<template>
<section id="topbar">
    <div class="right">
		<Language></Language>
        <div class="user">{{user.username}}</div>
		<div @click="logout()" id="logout" class="name" >{{$t('logout')}}</div>   
    </div>
</section>
</template>

<script>

  import i18n from '@/i18n';
  import Language from '@/components/ui/Language.vue';
  import {Api} from '@/core/api.js';
  const api = new Api();

  export default {
    name: 'Topbar',
    components: {Language},
    data(){
        return {

        }
    },
    computed: {},
    methods: {
        logout(){
            var self = this;
            api.get( 'logout' ).then( function ( data ) {
                self.$store.commit( 'user/setAuthenticate', false );
                self.$store.commit( 'setOverlayVisible', false );
                self.$store.commit( 'setUserMenuVisible', false);
                self.$router.replace( { name: 'login' } );
            });
        }
    },
    created() {},
    computed: {
        user(){
            return this.$store.getters['user/getUser'];
        }
    }
  }

</script>


<style lang="scss" scoped>
  #topbar {
      height: 70px;
      overflow: hidden;
      width: 100%;
      right: 0;
      top: 0;
	  padding: 10px 25px;
      z-index: $z-header;
  	  background-color: #fff;
    //   border-bottom: 1px solid #ddd;
      margin-left: 0;
      z-index: 22;
  }


  .right {
	  @include display-flex();
	  @include align-items();
	  padding: 0 12px;
      @include justify-content(flex-end);
      height: 100%;
      position: relative;
      float: right;
      width: 50%;

	#logout {
        @include background( $image: img('logout.svg'), $size: 20px, $position: left 6px center );
        padding-left: 33px;
        float: right;
        font-size: 16px;
        cursor: pointer;
		margin-left: 15px;
    }
    .user {
      margin-left: 15px;
    }
     
  }

  @include media(">phone", "<desktop") {
      #topbar {
          width: 100%;
          padding-left: 50px;
		  display: none;
      }

      #left-menu.opened ~ #main-content #topbar {
          padding-left: 0;
          padding-right: 50px;
      }


      .right {
        @include border-radius(100%);
        position: fixed;
        bottom: 5px;
        right: 15px;
        padding: 0;
        width: 40px;
        height: 40px;
        background-color: $main-color;

      }


  }

</style>
